export default "<div class=\"form-container\">\n  <div id=\"myPaymentForm\">\n    <ion-spinner color=\"primary\"></ion-spinner>\n  </div> \n</div> ";